import { ProjectInformation } from '@/app/api/morgan-thermal/project';

export const createInitialValues = (project?: ProjectInformation) => ({
  project: project?.project ?? '',
  customer: project?.customer ?? '',
  revisionNumber: project?.revisionNumber ?? '',
  revisionDate: project?.revisionDate ?? '',
});